export const API_URL = process.env.REACT_APP_RAYCHAT_API_URL;
export const RACHAT_WEB_APP_URL = process.env.REACT_APP_RAYCHAT_WEB_APP_URL;
export const RAYCHAT_DASHBOARD_URL =
  process.env.REACT_APP_RAYCHAT_DASHBOARD_URL;
export const RAYCHAT_LANDING_URL = process.env.REACT_APP_RAYCHAT_LANDING_URL;
export const API_BASE_URL = process.env.REACT_APP_RAYCHAT_BASE_API_PORT
  ? process.env.REACT_APP_RAYCHAT_BASE_API_URL +
    ":" +
    process.env.REACT_APP_RAYCHAT_BASE_API_PORT
  : process.env.REACT_APP_RAYCHAT_BASE_API_URL;
export const DEFAULT_AVATAR_URL =
  process.env.REACT_APP_RAYCHAT_DEFAULT_AVATAR_URL;
export const NOTIFICATION_URL = process.env.REACT_APP_RAYCHAT_NOTIFICATION_URL;
export const UPLOAD_FILE_URL = process.env.REACT_APP_RAYCHAT_UPLOAD_FILE_URL;
export const UPLOAD_BASE_URL = process.env.REACT_APP_RAYCHAT_BASE_UPLOAD_URL;
//
export const PACKAGE_UPGRADE_LINK = `${RAYCHAT_DASHBOARD_URL}/payment/package-upgrading`;
export const CONVS_CHARGE_LINK = `${RAYCHAT_DASHBOARD_URL}/payment/conversation-charging`;

export const WEBAPP_THEME_MODE_LIGHT = "light";
export const WEBAPP_THEME_MODE_DARK = "dark";

export const POPUP_NAMES = {
  NEW_FEATURES: "RAYCHAT_WEBAPP_NEW_FEATURES",
  NOTIF_POPUP: "RAYCHAT_NOTIF_HINT_POPUP",
};

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_RAYCHAT_FIREBASE_API_KEY,
  authAdmin: process.env.REACT_APP_RAYCHAT_FIREBASE_AUTH_ADMIN,
  databaseUrl: process.env.REACT_APP_RAYCHAT_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_RAYCHAT_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_RAYCHAT_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_RAYCHAT_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_RAYCHAT_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_RAYCHAT_FIREBASE_MEASUREMENT_ID,
  vapidKey: process.env.REACT_APP_RAYCHAT_FIREBASE_VAP_ID,
};
